import {configureStore} from '@reduxjs/toolkit'
import fullScreenOverlayReducer from '../layouts/FullScreenOverlay/FullScreenOverlaySlice'

import  overlayReducer from '../layouts/Overlay/overlaySlice'
import messagePopupReducer from '../layouts/MessagePopup/messagePopupSlice'
import collectionPathReducer from './slices/collectionPathSlice'
import collectionDataReducer from './slices/collectionDataSlice'
import saverReducer from './slices/saverSlice'
import guideReducer from './slices/guideSlice'
import editsMadeReducer from './slices/editsMadeSlice'
// import PdfFinderReducer from '../layouts/PdfFinder/PdfFinderSlice'

// import fileUploadProgressReducer from '../../../platform/src/features/files/FileUploadProgress/fileUploadProgressSlice'

import platformUiSlice from './slices/platformUiSlice'

const store = configureStore({
    middleware: (getDefaultMiddleware)=> {
        return getDefaultMiddleware({
            serializableCheck: false
        })
    },
    reducer: {

        //Clueso Home
        saver: saverReducer,
        collectionData: collectionDataReducer,
        collectionPath: collectionPathReducer,
        platformUi: platformUiSlice,
        
        //GENERAL
        fullscreenOverlay: fullScreenOverlayReducer,
        overlay:overlayReducer,
        messagePopup: messagePopupReducer,

        
        // EDITOR
        guide: guideReducer,
        editsMade: editsMadeReducer
    }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch


export default store
